
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { OwnerStmtExpDetailService } from '../owner-stmt-exp-detail.service';
import { OwnerStmtExpDetail } from '../owner-stmt-exp-detail';

@Component({
    selector: 'app-owner-stmt-exp-detail',
    templateUrl: './owner-stmt-exp-detail.component.html',
    styleUrls: ['./owner-stmt-exp-detail.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class OwnerStmtExpDetailComponent implements OnInit {
  properties: any;
  ownerStmtExpId: any;
  ownerStmtExpIdRequired: boolean;

  constructor(
    private primengConfig: PrimeNGConfig,
    private ownerStmtExpDetailService: OwnerStmtExpDetailService,
    private alertService: AlertService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) data: any) {
    this.formTitle = data.title,
		  this.ownerStmtExpId = data.ownerStmtExpId,
      this.ownerStmtExpDetail = data.ownerStmtExpDetail,
      this.statuses = ownerStmtExpDetailService.statuses;
  }

  @Input() ownerStmtExpDetail: OwnerStmtExpDetail;
  @Output() doAdd = new EventEmitter<any>();
  @Output() doUpdate = new EventEmitter<any>();
  @Output() doDelete = new EventEmitter<any>();

  // data
  ownerStmtExpDetailId: number;

  // forms
  form1: UntypedFormGroup;
  formLoading = false;
  formAlert: String;
  formTitle: String;

  statuses: any;

  validationMessages = {
    'ownerStmtExpDetailId': [],
    'payTo': [{ type: 'required', message: 'Please enter only numbers, characters not allowed' }],
    'title': [],
    'description': [],
    'srcStatus': [],
    'quantity': [],
    'amount': [],
    'taxAmount': [],
    'taxPct': [],
    'opsNotes': [],
    'ownerNotes': [],
    'ownerStmtExpId': [],
    'serviceProductId': [],
  };

  ngOnInit() {
    this.primengConfig.ripple = true;
    this.formBuild();

    // if we were passed the whole ownerStmtExpDetail object
    if (this.ownerStmtExpDetail) {
      this.ownerStmtExpDetailId = this.ownerStmtExpDetail.ownerStmtExpDetailId;
      this.fixDates();
      this.form1.patchValue(this.ownerStmtExpDetail);
    }
  }

  onFormDelete() {
    console.log('onRowDelete: ' + JSON.stringify(event));
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete Id# ' + this.ownerStmtExpDetailId + '?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.formDelete()
      },
      reject: () => {
        this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
      }
    });
  }

  formAdd() {
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      console.log('property-add post: ' + JSON.stringify(this.form1.value));
      this.formLoading = true;
      this.ownerStmtExpDetailService.add(this.form1.value)
        .subscribe(
          (res: any) => {
            console.log('property-add SUCCESS: ' + JSON.stringify(res));
            this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
            this.ownerStmtExpDetail = res.data.ownerStmtExpDetail;
            this.doAdd.emit(this.ownerStmtExpDetail);
          },
          (err: any) => {
            console.log('ownerStmtExpDetail-add FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { this.formLoading = false; });

    } catch (error) {
      this.alertService.error(error);
    }
  }

  formUpdate() {
    console.log('ownerStmtExpDetail: ' + JSON.stringify(this.form1.value));
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }
      this.formLoading = true;
    //  this.form1.value.ownerStmtExpId = this.ownerStmtExpId;
      this.ownerStmtExpDetailService.update(this.form1.value)
        .subscribe(
          (res: any) => {
            console.log('property-update SUCCESS: ' + JSON.stringify(res));
            this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
            this.ownerStmtExpDetail = res.data.ownerStmtExpDetail;
            this.doUpdate.emit(this.ownerStmtExpDetail);
          },
          (err: any) => {
            console.log('property-update FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { this.formLoading = false; });
    } catch (error) {
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  formDelete() {
    try {
      this.ownerStmtExpDetailService.delete(this.ownerStmtExpDetail.ownerStmtExpDetailId)
        .subscribe(
          (res: any) => {
            console.log('ownerStmtExpDetail-delete SUCCESS: ' + JSON.stringify(res));
            this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
            this.doDelete.emit(this.ownerStmtExpDetail);
          },
          (err: any) => {
            console.log('ownerStmtExpDetail-add FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { this.formLoading = false; });
    } catch (error) {
      this.alertService.error(error);
    }
  }

  formBuild() {
    this.form1 = this.formBuilder.group({
      ownerStmtExpDetailId: [this.ownerStmtExpDetailId],
      payTo: ['', Validators.required],
      title: [],
      description: [],
      srcStatus: [],
      quantity: [],
      amount: [],
      taxAmount: [],
      taxPct: [],
      opsNotes: [],
      ownerNotes: [],
      ownerStmtExpId: [this.ownerStmtExpId],
      serviceProductId: []
    });
  }

  fixDates() {
    // create date objects - why can't primeng do this?
    this.ownerStmtExpDetail.ownerStmtExpDetailDate = moment(this.ownerStmtExpDetail.ownerStmtExpDetailDate).toDate();
  }

  selectOwnerStmtExpDetail(){
		this.ownerStmtExpIdRequired = false;
	}
}
